// src/components/Header/index.jsx
import React from 'react';
import { Layout, Menu, Typography, Dropdown, Avatar, Space } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './index.css';

const { Header: AntHeader } = Layout;
const { Title } = Typography;

const AppHeader = ({ loggedInUser, onLogout }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const handleLogoutAndRedirect = () => {
        onLogout();
        navigate('/auth');
    };
    const userMenuItems = [
        {
            key: 'profile',
            label: <Link to="/about">个人主页</Link>,
            icon: <Avatar size="small" src={loggedInUser?.aboutInfo?.avatar || 'https://tu.tuhenmei.com/zb_users/upload/2023/06/202306131686617233591030.jpg'} />,
        },
        {
            type: 'divider',
        },
        {
            key: 'logout',
            label: '退出登录',
            danger: true,
            onClick: handleLogoutAndRedirect,
        },
    ];

    return (
        <AntHeader className="app-header">
            <div className="blog-logo">
                <Title level={3} style={{ margin: 0, color: '#fff' }}>
                    <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>我的博客</Link>
                </Title>
            </div>
            <Menu
                theme="dark"
                mode="horizontal"
                selectedKeys={[location.pathname]}
                className="header-menu"
                items={[
                    { key: '/', label: <Link to="/">首页</Link> },
                    { key: '/archive', label: <Link to="/archive">归档</Link> },
                    { key: '/write', label: <Link to="/write">写文章</Link> },
                    { key: '/about', label: <Link to="/about">我的</Link> },
                ]}
            />
            <div className="auth-menu-area">
                {loggedInUser ? (
                    <Dropdown menu={{ items: userMenuItems }} trigger={['click']}>
                        <a onClick={e => e.preventDefault()} style={{ color: '#fff', fontSize: '16px' }}>
                            <Space>
                                <Avatar size="small" src={loggedInUser.aboutInfo?.avatar || 'https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfpaHPjNOaH.png'} />
                                <span>欢迎，{loggedInUser.username}</span>
                            </Space>
                        </a>
                    </Dropdown>
                ) : (
                    <Link to="/auth" style={{ color: '#fff', fontSize: '16px', marginLeft: '20px' }}>
                        登录 / 注册
                    </Link>
                )}
            </div>
        </AntHeader>
    );
};

export default AppHeader;
